var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKlarna = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 78.536 17.531"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.82 0H9.953a9.9 9.9 0 0 1-3.988 7.977L4.439 9.121 10.37 17.2h4.869L9.78 9.763A13.67 13.67 0 0 0 13.82 0",
  "data-name": "Path 5936"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h3.954v17.202H0z",
  "data-name": "Rectangle 25304"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.387 0h3.728v17.202h-3.728z",
  "data-name": "Rectangle 25305"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.82 4.977a4.31 4.31 0 0 0-3.676 1.665V5.306h-3.538v11.9h3.59V10.96a2.505 2.505 0 0 1 2.67-2.688c1.561 0 2.462.936 2.462 2.67v6.277h3.555V9.642c0-2.775-2.202-4.665-5.063-4.665",
  "data-name": "Path 5937"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.387 5.306v.763a6.2 6.2 0 0 0-3.538-1.092 6.277 6.277 0 1 0 0 12.555 6.2 6.2 0 0 0 3.538-1.092v.763h3.555v-11.9Zm-3.243 9a3.057 3.057 0 1 1 3.225-3.052 3.14 3.14 0 0 1-3.225 3.052",
  "data-name": "Path 5938"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M40.456 6.849V5.306h-3.642v11.9h3.659v-5.553c0-1.873 2.029-2.879 3.433-2.879h.035V5.306a4.47 4.47 0 0 0-3.485 1.543",
  "data-name": "Path 5939"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M68.947 5.306v.763a6.2 6.2 0 0 0-3.538-1.092 6.277 6.277 0 1 0 0 12.555 6.2 6.2 0 0 0 3.538-1.092v.763h3.555v-11.9Zm-3.243 9a3.057 3.057 0 1 1 3.225-3.052 3.14 3.14 0 0 1-3.225 3.052",
  "data-name": "Path 5940"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9749"
}, /*#__PURE__*/React.createElement("path", {
  d: "M75.259 5.652a.274.274 0 0 0-.312-.277h-.33v.9h.156v-.329h.173l.139.329h.173l-.156-.364a.27.27 0 0 0 .157-.259m-.312.139h-.173v-.277h.173c.1 0 .156.052.156.139s-.035.138-.157.138Z",
  "data-name": "Path 5941"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.895 4.994a.85.85 0 0 0-.85.85.86.86 0 0 0 .85.85.85.85 0 1 0 0-1.7m0 1.543a.68.68 0 0 1-.676-.694.69.69 0 0 1 .676-.694.68.68 0 0 1 .676.694.69.69 0 0 1-.676.694",
  "data-name": "Path 5942"
}))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M76.299 12.988a2.237 2.237 0 1 0 2.237 2.237 2.24 2.24 0 0 0-2.237-2.237",
  "data-name": "Path 5943"
})));
export { SvgKlarna as ReactComponent };
export default "/_next/static/images/klarna.svg";